import { Injectable } from '@angular/core';
import { DataService } from '../data/data.service';
import { SignDocumentRequest } from '@shared/models/signrequest/sign.document.request';
import { SignResponse } from '@shared/models/signrequest/sign.response';
import { ZynyoDocument } from '@shared/models/document/zynyo.document';
import { Signatory } from '@shared/models/document/signatory';
import { DocumentInfo } from '@shared/models/signrequest/document.info';
import { DocumentUpdate } from '@shared/components/edit-signatory/edit-signatory.component';


@Injectable({
    providedIn: 'root'
})
export class SignrequestService extends DataService {
    static DOCUMENT_CANCELLED = 'Document successfully cancelled';

    override get url(): string {
        const base = this.configService.config?.apiBaseUrl ?? '';
        return `${base}sign`;
    }

    createSignDocumentRequest(signDocumentRequest: SignDocumentRequest, filename: string) {
        signDocumentRequest.documentInfo = new DocumentInfo(
            filename,
            signDocumentRequest.documentInfo.description);
        return this.create<SignResponse>(signDocumentRequest, 'multi/signdocumentrequest');
    }

    cancelDocument(zynyoDocument: ZynyoDocument) {
        return this.update<ZynyoDocument>({'documentUUID': zynyoDocument.documentUUID}, 'canceldocument');
    }

    remindSignatory(document: ZynyoDocument, signatory: Signatory) {
        return this.create({
            'documentUUID': document.documentUUID,
            'signatoryEmail': signatory.email,
            'reminderType': 'EMAIL'
        }, 'sendreminder');
    }

    updateSignatory(documentUpdate: DocumentUpdate) {
        return this.update<any>(documentUpdate, 'editdocument');
    }

    editSignatoriesRequest(zynyoDocument: ZynyoDocument, value: { name: string; email: string; mobilePhone: string; validUntil: string }) {
        return this.create<any>({
            'documentUUID': zynyoDocument.documentUUID,
            'mobilePhone': value.mobilePhone,
            'name': value.name,
            'email': value.email,
            'validUntil': value.validUntil
        }, 'createeditrequest');
    }

    deleteDocument(zynyoDocument: ZynyoDocument) {
        return this.delete({ documentUUID: zynyoDocument.documentUUID }, 'deletedocument');
    }
}
